<template lang="pug">
v-card.mb-3
  v-img(v-if="contents.image" @click="goToLink" :src="contents.image" :aspect-ratio="16/9")
  v-card-title.lighten-4(v-if="contents.showPanelTitle" :class="{ grey: !!contents.content }")
    router-link(v-if="contents.link" :to="contents.link").subheading {{extra.name}}
    .subheading(v-else) {{extra.name}}
  v-card-text.link-card-text(v-if="contents.content" v-html="contents.content")

</template>

<style lang="stylus" scoped>
.link-card-text
  >>> p:last-child
    margin-bottom 0

</style>


<script>
export default {
  props: ['extra'],
  computed: {
    contents() {
      if (this.extra && this.extra.content) {
        return JSON.parse(this.extra.content)
      } else {
        return {}
      }
    }
  },
  methods: {
    goToLink() {
      if (this.contents.link) {
        this.$router.push(this.contents.link)
      }
    }
  }
}
</script>
